pas<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <form @submit.prevent="checkJoinPw">
        <div class="join container">
          <div class="joinTitle">
            <h3>계정설정</h3>
            <p>회원정보변경을 위해 비밀번호를 입력해주세요.</p>
          </div>
          <div class="joinContext userInput">
            <div class="warnSpace">
              <p class="warn"  v-text="form.password.errorTxt" v-if="form.password.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.password.hasError}">
              <div class="inputHeader">
                <p>비밀번호</p>
              </div>
              <input type="password" v-model="form.password.value" maxlength="20" @keyup="blurPassword()"  placeholder="비밀번호를 입력해주세요."/>
            </div>
          </div>
        </div>
        <div class="btnWrap" :class="{visible : form.password.flag}">
          <button type="submit">다음</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapMutations, mapState } from 'vuex'
import router from '../../router'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '비밀번호변경',
        prevUrl: '/'
      },
      isChangePw: '',
      form: {
        password: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  computed: {
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/controllSetting')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    blurPassword () {
      this.form.password.flag = false
      this.checkPassword()
    },
    checkPassword () {
      if (this.form.password.flag) return true
      const password = this.form.password.value
      if (password === '') {
        this.form.password.hasError = true
        this.form.password.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      // const isPw = /^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])(?=.*[0-9]).{8,20}$/
      // if (!isPw.test(password)) {
      //   this.form.password.hasError = true
      //   this.form.password.flag = false
      //   this.form.password.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~20자를 설정해주세요.'
      //   return false
      // }
      this.form.password.flag = true
      this.form.password.hasError = false
      this.form.password.errorTxt = ''
      return true
    },
    async checkJoinPw () {
      if (this.form.password.value === '') {
        this.form.password.hasError = true
        this.form.password.errorTxt = '비밀번호를 입력해주세요.'
        this.popupSet.content = '비밀번호를 입력해주세요.'
        this.SET_POPUP(true)
        return false
      }
      try {
        const userData = {
          password: this.form.password.value
        }
        await this.CHECK_PW(userData)
          .then(() => {
            this.SET_REFERRER(window.location.href)
            router.push('/modifyUser/passwordChange')
          })
      } catch (error) {
        console.log('error :', error);
        console.log('비밀번호 체크 에러에 진입함!')
        if (error.status !== 401) {
          if (error.data.response.message === 'Invalid Password') {
            this.SET_POPUP(true)
            this.popupSet.content = '비밀번호를 확인해주세요.'
          } else {
            this.SET_POPUP(true)
            this.popupSet.content = '비밀번호를 확인해주세요.'
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.form.password.value = ''
        this.form.password.flag = false
      }
    },
    ...mapActions([
      'CHECK_PW'
    ])
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
  .join.container .joinTitle {
    margin: 0 0 15px 0;
  }
</style>
